/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 21/6/2023
 */

import { Box, Button, Container, Paper, Toolbar, Typography } from "@mui/material"
import { useDispatch } from "react-redux"
import CategoryDialog from "../Components/Category/CategoryDialog";
import NestedTable from "../Components/Category/NestedTable";
import { openAddCategoryModal } from "../Store/Slices/categorySlice";

import styles from "./Management.module.css"

const CategoryManagement = () => {

    const dispatch = useDispatch();

    const roles = sessionStorage.getItem("roles");

    return (
        roles?.split(",").includes("PRIV_ES_DISPLAY_CATEGORIES") ? (
        <Paper elevation={3} className={styles.pageContainer} style={{backgroundImage: `url(${process.env.REACT_APP_IMAGE_URL}E_SERVICE/thumbnail_Management.png)`}}>
            <Box>
                <Toolbar className={styles.subNavBar}>
                    <Typography className={styles.topic}>Category Management</Typography>
                    {roles?.split(",").includes("PRIV_ES_ADD_CATEGORY") ?  (<Button variant="contained" color="primary" className={styles.buttonItem} onClick={() => dispatch(openAddCategoryModal())}>Add Category</Button>) : null}
                </Toolbar>
            </Box>
            <Container id={styles.container}>

            </Container>

            <Container>
                <NestedTable />
            </Container>

            <CategoryDialog />

        </Paper> ) : null
    )
}

export default CategoryManagement
